import React from 'react';
import { Navigate } from 'react-router-dom';
import useHasMissingRequiredPersonalData from '../helpers/user/useHasMissingRequiredPersonalData';

function CheckRequiredPersonalData() {
  const hasMissing = useHasMissingRequiredPersonalData();

  if (hasMissing) {
    return <Navigate to="/profile" />;
  }

  return null;
}

export default CheckRequiredPersonalData;
